const itemContent = `
		<div style="text-align: justify;">

			<p class="mb-5 text-center">* * *</p>
			
			
			<p class="mb-3">
				Взрывы, взрывы… 
				Злые вопли сирен. 
				Дробь пулемёта. 
				Трассирующие ракеты в небе.
			
			<p class="mb-3">	
				А в окне напротив трассируют, мерцают огоньки на новогодней ёлке. 
				Продолжаются праздники: ведь сегодня Крещенье!
			</p>
			
			<p class="mb-3">	
				Мой город крещён огнём войны. Опалён огненным праздником. 
				Замерзает в ледяных объятьях. 
				Задыхается, удушенный ложью. 
				Сходит с ума, лишённый языка и права говорить на этом языке. 
				Слепнет, когда ему завязали глаза и стали уверять, что он идёт вперёд, 
				когда ему просто свернули шею, и «вперёд» стало значить «назад».
			</p>
			
			<p class="mb-3">	
				Мой город умирает.
			</p>
			
			<p class="mb-3">	
				Но только что было Рождество. 
				А за ним непременно следует Пасха. 
				«Христос воскрес!»
			</p>
			
			<p class="mb-3">	
				Христос воскреснет?
			</p>
				
			<p class="article-date mb-5"><span>18 января 2026 г.</span></p>

			
			<p class="mb-5 text-center">* * *</p>

			
			<p class="mb-3">
				Я услышала звук ключа, поворачиваемого в замке́. 
			</p>
			
			<p class="mb-3">
				Я одна дома, и я давно живу одна. 
				Никто не приходит ко мне, тем более, вечером; тем более, со своим ключом. 
				Все, кто жили в этом доме, давно умерли или уехали. 
				Я осталась одна.
			</p>
				
			<p class="mb-3">
				Но ключ поворачивается! 
				Кто-то хочет отпереть мою дверь и войти ко мне!
			</p>
			
			<p class="mb-3">
				Я подбегаю к двери и вижу, как медленно отходит назад лезвие замка́. 
				Я стою оцепенело… 
				Минута удушающего ужаса, этого нельзя вынести, я просыпаюсь со стоном…
			</p>
				
			<p class="mb-3">
				И я слышу звук ключа, поворачивающегося в замке́.
			</p>
			
			<p class="article-date mb-5"><span>18 января 2026 г.</span></p>
			
			
			<p class="mb-5 text-center">* * *</p>

			
			<p class="mb-3">
				Кривое зеркало жизни.
			</p>
				
			<p class="mb-3">
				Если пришёл сигнал письма в Телеграме – то это не письмо от друга, 
				а извещение о воздушной тревоге.
			</p>
				
			<p class="mb-3">
				Если звонок по телефону – то не дружеский привет, а сообщение, 
				что ты не заплатил по какой-то квитанции за какую-то коммунальную услугу.
			</p>
				
			<p class="mb-3">
				Если приходит письмо на электронную почту – то не от друга, 
				а из каких-нибудь инстанций, с предупреждением, угрозой или запретом.
			</p>
				
			<p class="mb-3">
				Всё, что было радостью человеческого общения, стало преградой этому общению: 
				бетонным забором, ограждающим для тебя зону бессилия и беспомощности, 
				где ты один на арене спасаешься от мчащихся на тебя танков. 
				Этакий современный вариант Колизея; но ты не гладиатор, 
				ты не заканчивал спецшколу и не снабжён хоть каким-то оружием. 
			</p>
				
			<p class="mb-3">
				С другой стороны, вокруг арены нет зрителей. 
				Тебе не аплодируют и не свистят; ты только один на этой бетонной сцене. 
				Людей нет вокруг; но и в мчащихся на тебя машинах людей тоже нет. 
				Человек там – только ты; всё остальное – бетон, металл, холод, смерть. 
			</p>
				
			<p class="mb-3">
				Наступление ИИ на человека. 
			</p>
	
			
			<p class="article-date mb-5"><span>19 января 2026 г.</span></p>
			
			
			<p class="mb-5 text-center">* * *</p>
			
			
			<p class="mb-3">
				В городе зима и война. 
				Не ходит электротранспорт, света нет по полсуток, а то и по суткам; также и отопления. 
				Сидим-дрожим от мысли, что если отключат ещё газ и воду, то погибнем точно. 
				Страшно.
			</p>
			
			<p class="mb-3">
				Вспоминаю старый туристский способ: кирпич нагреть на костре и завернуть в газеты. 
				Я так грелась в палатке, и хватало на всю ночь. 
				Да, хорошо; у нас перекладывали рельсы и что-то там валялось неубранное. 
				Думала, пойду поищу.
			</p>
			
			<p class="mb-3">
				По привычке пожаловалась внучке, которая живет в Амстердаме. 
			</p>
			
			<p class="mb-3">
				И вдруг мне приходит сообщение из службы доставки: она заказала мне три кирпича!!
			</p>
			
			<p class="mb-3">
				Их можно будет нагревать на газе и греться в комнатах! 
			</p>
			
			<p class="mb-3">
				То, что полвека назад делали в лесу, сейчас стало актуально в миллионном городе. 
				Как бурно развивается цивилизация!
			</p>

			<p class="article-date mb-5"><span>20 января 2026 г.</span></p>
			
			
			<p class="mb-5 text-center">* * *</p>


			<p class="mb-3">
				Я одна дома, и здесь темно. 
				Хмурый зимний день сменяется такой же ночью. 
				Нигде ни просвета: всё спит или умерло.
			</p>
			
			<p class="mb-3">
				Внезапно тьма заполняется ярким светом. 
				Нет, точнее свет заменяет тьму во всём пространстве, всём объёме; 
				там, где раньше господствовала тьма, теперь царит мягкий тёплый жёлтый свет. 
				Меняется мир; меняется космос, меняется время, меняется жизнь. 
			</p>
			
			<p class="mb-3">
				После суточного отключения дали свет.
			</p>

			<p class="article-date mb-5"><span>28 января 2026 г.</span></p>
`;

const formoj_malgrandaj = {
  // itemlink намеренно отсутствует
	hideBackButton: true,
  rus: {
    itemName: "Малые формы",
    itemContent
  }
};

export default [formoj_malgrandaj];